import React from "react";
import Section from "../../../utility/ui-components/section";
import Container from "../../../utility/ui-components/container";
import home from "../../../../common/assets/data/home";
import Marquee from "react-fast-marquee";
import SectionHeading from "../../../utility/ui-components/sectionHeading";

function PartnerSection() {
  const data = home.PartnerSection;
  return (
    <Section >
      <Container className="">
        <SectionHeading heading={data.Heading} />
        <Marquee speed={60} direction="right">
          <div className="flex items-center">
            {data.partnerlogos.map((items, index) => (
              <img
                key={index + 1}
                src={items.image}
                alt={items.alt}
                className="aspect-[16/9] w-[150px] object-contain mr-[16px]"
              />
            ))}
          </div>
        </Marquee>
      </Container>
    </Section>
  );
}

export default PartnerSection;
